const config = {
  clock: 'hmUI.system_status.CLOCK',
  disconnect: 'hmUI.system_status.DISCONNECT',
  dnd: 'hmUI.system_status.DISTURB',
  lock: 'hmUI.system_status.LOCK'
}

export default config
